import { render, staticRenderFns } from "./member-add.vue?vue&type=template&id=4b3513bb&scoped=true";
import script from "./member-add.vue?vue&type=script&lang=jsx";
export * from "./member-add.vue?vue&type=script&lang=jsx";
import style0 from "./member-add.vue?vue&type=style&index=0&id=4b3513bb&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "4b3513bb", null);
export default component.exports;